module.exports = __webpack_public_path__ + "static/media/flatworm.ad6d1393.jpg";